import { RouteRegistry } from '../federation';
import { EventBus } from '../messaging';
import { RuntimeLogger } from './RuntimeLogger';
import { addNavigationItem, addUserMenuItem } from '../../stores/navigation';
export class Runtime {
    _routeRegistry = new RouteRegistry();
    _shell;
    _rootComponents = [];
    _failedToFetchRemotes = [];
    _allRemotes = [];
    _logger;
    _eventBus;
    _services;
    _sessionAccessor;
    _fakes;
    constructor({ loggers = [], services, sessionAccessor, shell } = {}) {
        this._logger = new RuntimeLogger(loggers);
        this._eventBus = new EventBus({ logger: this._logger });
        this._services = services;
        this._sessionAccessor = sessionAccessor;
        this._shell = shell;
    }
    registerRoutes(routes) {
        if (routes) {
            this._routeRegistry.add(routes, this._shell);
            this._logger.debug('[shell] The following routes has been registered', routes);
        }
        return routes;
    }
    get routes() {
        return this._routeRegistry.routes;
    }
    registerNavigationItems(navigationItems) {
        if (navigationItems) {
            navigationItems.forEach(item => {
                addNavigationItem(item);
            });
            this._logger.debug('[shell] The following navigation items has been registered', navigationItems);
        }
    }
    registerUserMenuItems(userMenuItems) {
        if (userMenuItems) {
            userMenuItems.forEach(item => {
                addUserMenuItem(item);
            });
            this._logger.debug('[shell] The following user menu items have been registered', userMenuItems);
        }
    }
    registerRootComponents(rootComponents) {
        if (rootComponents) {
            this._rootComponents = this._rootComponents.concat(rootComponents);
        }
    }
    setFailedToFetchRemotes(failedToFetchRemotes) {
        if (failedToFetchRemotes) {
            this._failedToFetchRemotes = failedToFetchRemotes;
        }
    }
    setAllRemotes(allRemotes) {
        if (allRemotes) {
            this._allRemotes = allRemotes;
        }
    }
    setFakes(useAuthorizationOrganizationFakes) {
        this._fakes = useAuthorizationOrganizationFakes;
    }
    get logger() {
        return this._logger;
    }
    get eventBus() {
        return this._eventBus;
    }
    get failedToFetchRemotes() {
        return this._failedToFetchRemotes;
    }
    get allRemotes() {
        return this._allRemotes;
    }
    get rootComponents() {
        return this._rootComponents;
    }
    get fakes() {
        return this._fakes;
    }
    getService(serviceName) {
        return this._services[serviceName];
    }
    getSession() {
        if (!this._sessionAccessor) {
            throw new Error('[shell] Cannot retrieve the session because no session accessor has been provided');
        }
        return this._sessionAccessor();
    }
    set shell(shell) {
        this._shell = shell;
        this._logger.debug('[shell] The following shell has been registered', shell);
    }
    get shell() {
        return this._shell;
    }
}
